import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'

// Connects to data-controller="supervised-person"
export default class SupervisedPersonController extends Controller {
  // Declarations for targets
  declare readonly hiddenRepCodeTarget: HTMLInputElement
  declare readonly repCodeDisplayTarget: HTMLInputElement
  declare readonly repCodeSelectTarget: HTMLSelectElement & { tomselect: TomSelect }

  // Declarations for target presence checks
  declare readonly hasHiddenRepCodeTarget: boolean
  declare readonly hasRepCodeDisplayTarget: boolean
  declare readonly hasRepCodeSelectTarget: boolean

  static targets = [
    "hiddenRepCode",
    "repCodeDisplay",
    "repCodeSelect", 
  ]

  updateHiddenField(
    managerName?: string, 
    repCode?: string
  ) {
    // Clear fields if no manager data is provided
    if (!managerName || !repCode) {
      this.repCodeDisplayTarget && (this.repCodeDisplayTarget.value = '')
      this.hiddenRepCodeTarget && (this.hiddenRepCodeTarget.value = '')
      return
    }

    // Set the display field with formatted manager info
    if (this.repCodeDisplayTarget) {
      this.repCodeDisplayTarget.value = `${managerName} - ${repCode}`
    }

    if (this.hiddenRepCodeTarget) {
      this.hiddenRepCodeTarget.value = repCode || ''
    }
  }

  updateSelectField(
    repCode?: string
  ) {
    if (!repCode) return

    const key = repCode.split(' ')[0]
    const tomSelect = this.repCodeSelectTarget.tomselect
    const selectedDropdown = tomSelect.options[key]

    if (selectedDropdown) {
      tomSelect.setValue(selectedDropdown.value)
    }
  }
}